import { IneligibleLinesReason } from '../../typings';

interface GetIneligibleWarningMessageProps {
  hasLines: boolean;
  reason?: IneligibleLinesReason;
}

const ineligibleToAddToCartReasons: IneligibleLinesReason[] = [
  'LINE_ALREADY_PRESENT_IN_CART',
  'IFP_LIMIT',
];

export const LINE_ALREADY_PRESENT_IN_CART_MESSAGE =
  'This plan has already been applied to another cart item. Choose a different plan, or remove item from cart.';
export const NON_ELIGIBLE_PLAN_MESSAGE =
  'This plan is not eligible for interest free payment (IFP). Please choose a plan that is eligible for IFP or change your plan.';
export const NO_ELIGIBLE_LINES_MESSAGE =
  'You currently have no plans that are eligible for interest free payment (IFP). Please choose a new plan that is eligible for IFP or contact us for more information.';

export const getIneligibleWarningMessage = ({
  hasLines,
  reason,
}: GetIneligibleWarningMessageProps): string => {
  if (!hasLines) return NO_ELIGIBLE_LINES_MESSAGE;
  if (ineligibleToAddToCartReasons.includes(reason))
    return LINE_ALREADY_PRESENT_IN_CART_MESSAGE;
  return NON_ELIGIBLE_PLAN_MESSAGE;
};
